document.addEventListener("DOMContentLoaded", function() {
  var modal = document.getElementById("landing-newsletter-modal");
var btns = document.querySelectorAll(".openpopup");
  var close = document.querySelector(".landing-close");

  // Open popup
 btns.forEach(function(btn) {
  btn.addEventListener("click", function() {
    modal.style.display = "flex";
  });
});

  // Close popup
  close.addEventListener("click", function() {
    modal.style.display = "none";
  });

  // Close on outside click
  window.addEventListener("click", function(e) {
    if (e.target === modal) {
      modal.style.display = "none";
    }
  });

  var form = document.getElementById("newsletter-form");
  var wrapper = document.getElementById("newsletter-wrapper");
  var success = document.getElementById("newsletter-success");

  if (form) {
    form.addEventListener("submit", function(e) {
      e.preventDefault(); // stop Shopify default redirect

      var formData = new FormData(form);
      var actionUrl = form.getAttribute("action");

      fetch(actionUrl, {
        method: "POST",
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.text())
      .then(() => {
        // Hide form and show success
        wrapper.style.display = "none";
        success.style.display = "block";

        // Wait 5 seconds then refresh **same page**
        setTimeout(function() {
          window.location.reload();
        }, 8000);
      })
      .catch(() => {
        alert("Something went wrong. Please try again.");
      });
    });
  }
});

$(document).ready(function() {
  $('#newsletter-form').on('submit', function(e) {
    e.preventDefault(); // stop redirect

    // Hide elements after submit
    $('.hidethisaftersubmit').hide();

    // Optionally show thank you message
    $('#newsletter-success').show();
  });
});





$(document).ready(function() {
    // Countdown Timer
    let timeLeft = {
        days: 1,
        hours: 8,
        minutes: 45
    };

    function updateCountdown() {
        $('#days').text(timeLeft.days.toString().padStart(2, '0'));
        $('#hours').text(timeLeft.hours.toString().padStart(2, '0'));
        $('#minutes').text(timeLeft.minutes.toString().padStart(2, '0'));
    }

    function decrementTime() {
        if (timeLeft.minutes > 0) {
            timeLeft.minutes--;
        } else if (timeLeft.hours > 0) {
            timeLeft.hours--;
            timeLeft.minutes = 59;
        } else if (timeLeft.days > 0) {
            timeLeft.days--;
            timeLeft.hours = 23;
            timeLeft.minutes = 59;
        }
        updateCountdown();
    }

    // Update countdown every minute
    setInterval(decrementTime, 60000);
    
    // Initial countdown display
    updateCountdown();

    // Smooth scrolling for anchor links
    $('a[href^="#"]').on('click', function(e) {
        e.preventDefault();
        
        const target = $(this.getAttribute('href'));
        
        if (target.length) {
            $('html, body').stop().animate({
                scrollTop: target.offset().top - 80
            }, 1000);
        }
    });

    // Add animation classes on scroll
    function animateOnScroll() {
        $('.feature-card, .card, .countdown-item').each(function() {
            const elementTop = $(this).offset().top;
            const elementBottom = elementTop + $(this).outerHeight();
            const viewportTop = $(window).scrollTop();
            const viewportBottom = viewportTop + $(window).height();

            if (elementBottom > viewportTop && elementTop < viewportBottom) {
                $(this).addClass('animate-fade-in');
            }
        });
    }

    // Trigger animation on scroll
    $(window).on('scroll', animateOnScroll);
    
    // Trigger animation on page load
    animateOnScroll();

    // Button hover effects
    $('.btn').hover(
        function() {
            $(this).addClass('shadow-lg');
        },
        function() {
            $(this).removeClass('shadow-lg');
        }
    );

    // Feature card hover effects
    $('.feature-card').hover(
        function() {
            $(this).find('.feature-icon').addClass('shadow');
        },
        function() {
            $(this).find('.feature-icon').removeClass('shadow');
        }
    );

    // Testimonial card hover effects
    $('.card').hover(
        function() {
            $(this).css('transform', 'translateY(-5px)');
        },
        function() {
            $(this).css('transform', 'translateY(0)');
        }
    );

    // WhatsApp button functionality
    $('button:contains("JOIN VIA WHATSAPP")').on('click', function() {
        // Replace with actual WhatsApp number
        const whatsappNumber = '9216035312';
        const message = 'Hi! I\'m interested in Style Story\'s personal styling service.';
        const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
        window.open(whatsappUrl, '_blank');
    });



    // Social media links
    $('.footer-social').on('click', function() {
        const platform = $(this).hasClass('fa-instagram') ? 'instagram' : 
                        $(this).hasClass('fa-twitter') ? 'twitter' : 'facebook';
        
        const urls = {
            instagram: 'https://instagram.com/stylestory',
            twitter: 'https://twitter.com/stylestory',
            facebook: 'https://facebook.com/stylestory'
        };
        
        window.open(urls[platform], '_blank');
    });

    // Parallax effect for hero section
    $(window).scroll(function() {
        const scrolled = $(window).scrollTop();
        const rate = scrolled * -0.5;
        
        $('#hero').css('transform', `translateY(${rate}px)`);
    });

    // Loading animation
    $('body').addClass('animate-fade-in');
});

// Additional utility functions
function formatTime(time) {
    return time.toString().padStart(2, '0');
}

function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}